var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssThemedValue, cssVarsThemed, typographyCss } from '@creditornot/cb-ingredients';
import { Spinner } from '@creditornot/cb-progress';
import { createCssVarDefinitions, createCssVars, themedConfigToThemedAttrs, } from '@creditornot/cb-utils';
import FadeTransition from './FadeTransition';
var sizeConfigs = {
    tiny: {
        minHeight: 24,
        verticalPadding: 4,
        horizontalPadding: 8,
        stretchModeHorizontalPadding: 8,
        iconMargin: 4,
        iconWidth: 12,
        spinnerSize: 14,
    },
    small: {
        minHeight: 36,
        verticalPadding: 8,
        horizontalPadding: 16,
        stretchModeHorizontalPadding: 16,
        iconMargin: 8,
        iconWidth: 12,
        spinnerSize: 18,
    },
    large: {
        minHeight: 56,
        verticalPadding: 8,
        horizontalPadding: 32,
        stretchModeHorizontalPadding: 24,
        iconMargin: 12,
        iconWidth: 16,
        spinnerSize: 24,
    },
};
export var cssVars = createCssVars([
    'minHeight',
    'verticalPadding',
    'horizontalPadding',
    'stretchModeHorizontalPadding',
    'iconMargin',
    'iconWidth',
    'spinnerSize',
]);
export var variantConfigs = {
    blue: {
        light: {
            color: colors.salt100,
            background: colors.wolt100,
            backdrop: 'transparent',
            backgroundOnHover: colors.wolt92,
            backgroundOnActive: colors.wolt84,
            backgroundDisabled: colors.wolt64,
            colorDisabled: colors.salt48,
            fontWeight: '700',
        },
        dark: {
            color: colors.space100,
            background: colors.wolt100,
            backdrop: 'transparent',
            backgroundOnHover: colors.wolt88,
            backgroundOnActive: colors.wolt76,
            backgroundDisabled: colors.wolt60,
            colorDisabled: colors.space48,
            fontWeight: '700',
        },
    },
    lightBlue: {
        light: {
            color: colors.wolt100,
            background: colors.wolt8,
            backdrop: 'transparent',
            backgroundOnHover: colors.wolt12,
            backgroundOnActive: colors.wolt24,
            backgroundDisabled: colors.wolt8,
            colorDisabled: colors.wolt40,
            fontWeight: '500',
        },
        dark: {
            color: colors.wolt100,
            background: colors.wolt12,
            backdrop: 'transparent',
            backgroundOnHover: colors.wolt16,
            backgroundOnActive: colors.wolt28,
            backgroundDisabled: colors.wolt12,
            colorDisabled: colors.wolt48,
            fontWeight: '500',
        },
    },
    lightRed: {
        light: {
            color: colors.strawberry100,
            background: colors.strawberry8,
            backdrop: 'transparent',
            backgroundOnHover: colors.strawberry12,
            backgroundOnActive: colors.strawberry24,
            backgroundDisabled: colors.strawberry8,
            colorDisabled: colors.strawberry40,
            fontWeight: '700',
        },
        dark: {
            color: colors.strawberry100,
            background: colors.strawberry12,
            backdrop: 'transparent',
            backgroundOnHover: colors.strawberry16,
            backgroundOnActive: colors.strawberry28,
            backgroundDisabled: colors.strawberry12,
            colorDisabled: colors.strawberry48,
            fontWeight: '700',
        },
    },
    white: {
        light: {
            color: colors.pepper64,
            background: colors.salt100,
            backdrop: colors.salt100,
            backgroundOnHover: colors.pepper8,
            backgroundOnActive: colors.pepper12,
            backgroundDisabled: colors.salt100,
            colorDisabled: colors.pepper40,
            fontWeight: '500',
        },
        dark: {
            color: colors.salt100,
            background: colors.space100,
            backdrop: colors.space100,
            backgroundOnHover: colors.salt12,
            backgroundOnActive: colors.salt16,
            backgroundDisabled: colors.space88,
            colorDisabled: colors.salt48,
            fontWeight: '500',
        },
    },
};
var spinnerColorConfig = {
    blue: 'white',
    lightBlue: 'blue',
    lightRed: 'red',
    white: 'grey',
};
var variantCssVars = createCssVars([
    'color',
    'background',
    'backdrop',
    'backgroundOnHover',
    'backgroundOnActive',
    'backgroundDisabled',
    'colorDisabled',
    'fontWeight',
]);
var StretchModeIconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n  transition: opacity 150ms ease-in;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  padding: ", " ", ";\n"], ["\n  opacity: ", ";\n  transition: opacity 150ms ease-in;\n\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  padding: ", " ", ";\n"])), function (_a) {
    var $visible = _a.$visible;
    return ($visible ? 1 : 0);
}, function (_a) {
    var $position = _a.$position;
    return ($position === 'left' ? 'flex-start' : 'flex-end');
}, cssVars.verticalPadding, cssVars.stretchModeHorizontalPadding);
var IconContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-inline-start: ", ";\n  margin-inline-end: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-inline-start: ", ";\n  margin-inline-end: ", ";\n"])), function (_a) {
    var $position = _a.$position;
    return ($position === 'left' ? 0 : cssVars.iconMargin);
}, function (_a) {
    var $position = _a.$position;
    return ($position === 'right' ? 0 : cssVars.iconMargin);
});
var BG = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n"])));
var Root = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  /* normalize */\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  border: none;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  box-sizing: border-box;\n  position: relative;\n  z-index: 0;\n  user-select: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n\n  ", "\n\n  width: ", ";\n  max-width: 100%;\n\n  cursor: pointer;\n  padding: ", " ", ";\n  font-weight: ", ";\n  min-height: ", ";\n  border-radius: 8px;\n\n  background: ", ";\n\n  ", " {\n    background: ", ";\n  }\n  &:disabled ", " {\n    background: ", ";\n  }\n\n  color: ", ";\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  ", ", ", " {\n    svg {\n      width: ", ";\n      fill: ", ";\n    }\n  }\n\n  &:disabled ", ", &:disabled ", " {\n    > svg {\n      fill: ", ";\n    }\n  }\n\n  &:hover:not(:disabled) ", " {\n    background: ", ";\n  }\n  &:active:not(:disabled) ", " {\n    background: ", ";\n  }\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px ", ";\n  }\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @keyframes zoomIn {\n    0% {\n      transform: scale(0.4);\n    }\n\n    75% {\n      transform: scale(1.1);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  @keyframes zoomOut {\n    0% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(0.4);\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n"], ["\n  ", "\n\n  ", "\n\n  /* normalize */\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  border: none;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  box-sizing: border-box;\n  position: relative;\n  z-index: 0;\n  user-select: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n\n  ", "\n\n  width: ", ";\n  max-width: 100%;\n\n  cursor: pointer;\n  padding: ", " ", ";\n  font-weight: ", ";\n  min-height: ", ";\n  border-radius: 8px;\n\n  background: ", ";\n\n  ", " {\n    background: ", ";\n  }\n  &:disabled ", " {\n    background: ", ";\n  }\n\n  color: ", ";\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  ", ", ", " {\n    svg {\n      width: ", ";\n      fill: ", ";\n    }\n  }\n\n  &:disabled ", ", &:disabled ", " {\n    > svg {\n      fill: ", ";\n    }\n  }\n\n  &:hover:not(:disabled) ", " {\n    background: ", ";\n  }\n  &:active:not(:disabled) ", " {\n    background: ", ";\n  }\n\n  :focus:not(:focus-visible) {\n    outline: none;\n  }\n  :focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px ", ";\n  }\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @keyframes zoomIn {\n    0% {\n      transform: scale(0.4);\n    }\n\n    75% {\n      transform: scale(1.1);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  @keyframes zoomOut {\n    0% {\n      transform: scale(1);\n    }\n    100% {\n      transform: scale(0.4);\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n"])), function (_a) {
    var $cssVarOverrides = _a.$cssVarOverrides, $size = _a.$size;
    return createCssVarDefinitions(__assign({ minHeight: "".concat(sizeConfigs[$size].minHeight, "px"), verticalPadding: "".concat(sizeConfigs[$size].verticalPadding, "px"), horizontalPadding: "".concat(sizeConfigs[$size].horizontalPadding, "px"), stretchModeHorizontalPadding: "".concat(sizeConfigs[$size].stretchModeHorizontalPadding, "px"), iconMargin: "".concat(sizeConfigs[$size].iconMargin, "px"), iconWidth: "".concat(sizeConfigs[$size].iconWidth, "px"), spinnerSize: "".concat(sizeConfigs[$size].spinnerSize, "px") }, $cssVarOverrides));
}, function (_a) {
    var $variant = _a.$variant;
    return cssVarsThemed(themedConfigToThemedAttrs(variantConfigs[$variant]));
}, function (_a) {
    var $size = _a.$size;
    switch ($size) {
        case 'tiny':
            return typographyCss.Small;
        case 'small':
            return typographyCss.Body3;
        case 'large':
            return typographyCss.Body2;
    }
}, function (_a) {
    var $stretch = _a.$stretch;
    return ($stretch ? '100%' : 'auto');
}, cssVars.verticalPadding, cssVars.horizontalPadding, variantCssVars.fontWeight, cssVars.minHeight, variantCssVars.backdrop, BG, variantCssVars.background, BG, variantCssVars.backgroundDisabled, variantCssVars.color, variantCssVars.colorDisabled, IconContainer, StretchModeIconContainer, cssVars.iconWidth, variantCssVars.color, IconContainer, StretchModeIconContainer, variantCssVars.colorDisabled, BG, variantCssVars.backgroundOnHover, BG, variantCssVars.backgroundOnActive, cssThemedValue('a11yFocusIndicator'));
var Content = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  z-index: 1;\n  display: flex;\n  align-items: center;\n\n  opacity: ", ";\n  transition: opacity 150ms ease-in;\n\n  overflow: hidden;\n\n  padding: ", ";\n"], ["\n  z-index: 1;\n  display: flex;\n  align-items: center;\n\n  opacity: ", ";\n  transition: opacity 150ms ease-in;\n\n  overflow: hidden;\n\n  padding: ", ";\n"])), function (_a) {
    var $visible = _a.$visible;
    return ($visible ? 1 : 0);
}, function (_a) {
    var $stretch = _a.$stretch, $withIcon = _a.$withIcon;
    // additional padding for content to prevent becoming
    // attachted to the icon when shrunk
    if ($stretch && $withIcon) {
        return "0px calc(".concat(cssVars.iconWidth, " * 1.5)");
    }
    return '0px';
});
var Label = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var SpinnerContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Button = React.forwardRef(function (_a, ref) {
    var children = _a.children, cssVarOverrides = _a.cssVarOverrides, _b = _a.disabled, disabled = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'left' : _c, loading = _a.loading, onClick = _a.onClick, _d = _a.role, role = _d === void 0 ? 'button' : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, _f = _a.stretch, stretch = _f === void 0 ? false : _f, _g = _a.type, type = _g === void 0 ? 'button' : _g, _h = _a.variant, variant = _h === void 0 ? 'blue' : _h, restButtonProps = __rest(_a, ["children", "cssVarOverrides", "disabled", "icon", "iconPosition", "loading", "onClick", "role", "size", "stretch", "type", "variant"]);
    return (React.createElement(Root, __assign({ "$cssVarOverrides": cssVarOverrides, "$size": size, "$stretch": stretch, "$variant": variant, disabled: disabled, onClick: disabled ? undefined : onClick, role: role, type: type }, restButtonProps, { ref: ref }),
        React.createElement(BG, null),
        React.createElement(SpinnerContainer, null,
            React.createElement(FadeTransition, { show: !!loading },
                React.createElement(Spinner, { color: spinnerColorConfig[variant], cssVarOverrides: { size: "".concat(sizeConfigs[size].spinnerSize, "px") }, size: "tiny" // size is overridden with cssVarOverrides
                 }))),
        stretch && (React.createElement(StretchModeIconContainer, { "$position": iconPosition, "$visible": !loading }, icon)),
        React.createElement(Content, { "$stretch": stretch, "$visible": !loading, "$withIcon": !!icon },
            !stretch && !!icon && iconPosition === 'left' && (React.createElement(IconContainer, { "$position": iconPosition }, icon)),
            React.createElement(Label, null, children),
            !stretch && !!icon && iconPosition === 'right' && (React.createElement(IconContainer, { "$position": iconPosition }, icon)))));
});
Button.displayName = 'Button';
export default Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Button.js.map